<template>
  <div>
    <pushMessage />
    <!--固定头部-->
    <nav-bar :state="stateIf" v-on:sx="refreshh" />
    <keep-alive>
      <router-view v-if="routerAlive" />
    </keep-alive>
    <!--固定底部-->
    <footerBar />
  </div>
</template>
<script>
  import NavBar from '@/views/nav'
  import pushMessage from '@/components/pushMessage/pushMessage.vue'
  import footerBar from '@/views/footer'
  export default {
    components: {
      NavBar,
      footerBar,
      pushMessage
    },
    data() {
      return {
        stateIf: false,
        routerAlive: true
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true)
    },
    provide() {
      routerRefresh: this.routerRefresh
    },
    methods: {
      handleScroll() {
        // 滚轮高度
        var top = window.parent.document.documentElement.scrollTop
        // 可视区高度
        // var keshi = document.body.scrollHeight
        // 文档高度
        // var scrollheight = document.documentElement.clientHeight
        if (top > 0) {
          this.stateIf = true
        } else {
          this.stateIf = false
        }
      },
      refreshh() {
         console.log("123refreshhrefreshhrefreshh")
      },
      routerRefresh() {
        console.log("routerRefresh")
        this.routerAlive = false;
        this.$nextTick(() => {

          this.routerAlive = true;
        });

      }
    }
  }
</script>
<style>
  .el-message {
    min-width: 2rem
  }
</style>
